import { render } from "./BaseFieldSelect.vue?vue&type=template&id=5d1d6211"
import script from "./BaseFieldSelect.vue?vue&type=script&lang=js"
export * from "./BaseFieldSelect.vue?vue&type=script&lang=js"

import exportComponent from "/builds/rclass/new_shlepakov/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__